export default __webpack_public_path__ + "static/media/2_0110.922eee22.webp";